import type { SmsTemplate as SmsTemplateData } from '@mathflat/domain/Sms'
import { makeObservable, observable } from 'mobx'

import { EMPTY_NUMBER_ID, EMPTY_STRING_ID } from '@/constant/common'

import { DTO } from '../DTO'

export class SmsTemplate extends DTO implements SmsTemplateData {
  id: SmsTemplateData['id'] = EMPTY_NUMBER_ID
  academyId: SmsTemplateData['academyId'] = EMPTY_STRING_ID
  type: SmsTemplateData['type'] = 'CUSTOM'
  title: SmsTemplateData['title'] = ''
  content: SmsTemplateData['content'] = ''
  templateSendingType: SmsTemplateData['templateSendingType'] = null

  constructor(data?: SmsTemplateData) {
    super()

    makeObservable(this, {
      id: observable,
      academyId: observable,
      type: observable,
      title: observable,
      content: observable,
    })
    if (data) {
      this.id = data.id
      this.academyId = data.academyId
      this.type = data.type
      this.title = data.title
      this.content = data.content
      this.templateSendingType = data.templateSendingType
    }
  }
}
